<template>
  <div class="tab-pane fade" id="scenic-parking" role="tabpanel" aria-labelledby="scenic-parking-tab">
    <div class="container-fluid">
      <div>
        <!--車位設定-->
        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <!-- <div class="h5 mb-0 font-weight-bold text-primary">車位設定</div>
            <hr /> -->
            <div class="row">
              <div class="col-12 table-responsive">
                <table :class="tableStyle" >
                  <thead class="table-dark text-center">
                    <tr>
                      <th scope="col" width="10%">#</th>
                      <th scope="col" width="20%">風景區</th>
                      <th scope="col" width="35%">現行車位</th>
                      <th scope="col" width="35%">修改車位</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in scenicAreaList" :key="key">
                      <td :class="tableCenterStyle">{{ key + 1 }}</td>
                      <td :class="tableCenterStyle">{{ item.name }}</td>
                      <td :class="tableCenterStyle">
                        {{
                          `大型車: ${item.fullSizeCarNumber} | 小型車: ${item.compactCarNumber} | 機車: ${item.motorcycleNumber}`
                        }}
                      </td>
                      <td :class="tableCenterStyle">
                        <button class="btn btn-primary bg-indigo" @click="editParkingSpace(item)">
                          編輯
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <dialog-modal
      ref="ParkingSapceEditor"
      :showUpdateButton="true"
      customUpdateButton="修改"
      :modalSize="''"
      :isImage="false"
      :isMarginAuto="false"
      @update-button-click="updateParkingSpace"
    >
      <div class="pb-1" v-if="selectScenicArea != null"> <!--using v-if for avoid to selectScenicArea is not defined -->   
        <div class="form-group h6">
          <label for="exampleInputEmail1">大型車</label>
          <input
            type="number"
            class="form-control"
            min="0"
            v-model.number="selectFullSizeCarNumber"
          />
        </div>
        <div class="form-group h6">
          <label for="exampleInputEmail1">小型車</label>
          <input
            type="number"
            class="form-control"
            min="0"
            v-model.number="selectCompactCarNumber"
          />
        </div>
        <div class="form-group h6">
          <label for="exampleInputEmail1">機車</label>
          <input
            type="number"
            class="form-control"
            min="0"
            v-model.number="selectMotorcycleNumber"
          />
        </div>
      </div>
    </dialog-modal>

    <!-- Modal -->
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from 'vuex'
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import { getCountPerHour } from '../../api/elasticSearch/vehicleplateApi'
import exportCSV from '../../utils/exportCSV'
import DialogModal from '../../components/DialogModal.vue'


export default {
  data() {
    return {
      CONST: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      selectScenicArea: null,
      selectFullSizeCarNumber: 0,
      selectCompactCarNumber: 0,
      selectMotorcycleNumber: 0,
    };
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
  },
  watch: {

  },
  methods: {
    editParkingSpace(item) {
      this.$refs.ParkingSapceEditor.openModal()
      this.selectScenicArea = item
      this.selectFullSizeCarNumber = item.fullSizeCarNumber
      this.selectCompactCarNumber = item.compactCarNumber
      this.selectMotorcycleNumber = item.motorcycleNumber
    },

    async updateParkingSpace() {
      if( this.selectFullSizeCarNumber < 0 ||
          this.selectCompactCarNumber < 0 || 
          this.selectMotorcycleNumber < 0) {
            alert("車位不可以為負數")
            return
      }

      this.selectScenicArea.fullSizeCarNumber = this.selectFullSizeCarNumber
      this.selectScenicArea.compactCarNumber = this.selectCompactCarNumber
      this.selectScenicArea.motorcycleNumber = this.selectMotorcycleNumber
      const result = await this.$store.dispatch('scenicArea/putScenicArea', this.selectScenicArea)

      if (result.success) {
        this.$refs.ParkingSapceEditor.closeModal();
      } else {
        alert('修改失敗')
      }
    },
  },
  mounted() {
    // this.$store.dispatch('passengerEstimateSetting/getEstimate')
  },
  components: { DialogModal },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
</style>
